module.exports = __webpack_public_path__ + "img/nations.0533a8b5.png";